import { AfterViewInit, Directive, ElementRef, Input, NgZone } from '@angular/core';

@Directive({
  selector: '[appFitTextToLines]',
  standalone: true
})
export class FitTextToLinesDirective implements AfterViewInit {
  @Input() maxFontSize = 16;
  @Input() minFontSize = 8;
  @Input() lineCount = 2;

  constructor(
    private el: ElementRef,
    private zone: NgZone
  ) {}

  ngAfterViewInit() {
    this.zone.runOutsideAngular(() => {
      requestAnimationFrame(() => this.adjust());
    });
  }

  private adjust() {
    const el = this.el.nativeElement as HTMLElement;
    const style = getComputedStyle(el);

    const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.2;

    const maxHeight = lineHeight * this.lineCount;

    let fontSize = this.maxFontSize;
    el.style.fontSize = `${fontSize}px`;

    while (fontSize > this.minFontSize && el.scrollHeight > maxHeight) {
      fontSize -= 0.5;
      el.style.fontSize = `${fontSize}px`;
    }
  }
}
